import { Box, Button } from "@mui/material";
  
  export interface ButtonCustomProps {
    text: string;
    event?: any;
    disabled?:boolean;
  }
  
  
  const ButtonCustom = (props: ButtonCustomProps) => {
    return (
        <Box sx={{display: 'flex', justifyContent: 'end'}}>
           <Button
           disabled={props.disabled}
        variant="contained"
        onClick={props.event}

        sx={{
          marginTop: '16px',
          color: 'white',
          ":hover": {
            background: '#FFC72C'
          },
          background: '#FFC72C',
          '&:disabled': {
            background: '#A0A0A0', // Change this to the desired color for disabled state
            color: 'rgba(255, 255, 255, 0.7)', // Change this to the desired color for disabled text
          },
        }}

      >
        {props.text}
      </Button>
        </Box>
       
    )


  }


  export default ButtonCustom